import AbstractMediator from "../../../core/ui/AbstractMediator";

export default class AbstractContentIndicatorButtonMediator extends AbstractMediator {
    constructor(target, dispatcher, soundManager) {
        super(target, dispatcher);

        this._target.gotoAndStop(0);
        this._soundManager = soundManager;
        if (this._target.button) {
            this._button = this.createButton(this._target.button, this._handleButtonClick.bind(this));
        }
    }

    initialize() {
        super.initialize();

        if (!this._target.getBounds()) {
            this._target.setBounds(this._target.nominalBounds);
        }
    }

    _handleButtonClick() {}
}